import React, { VFC } from 'react';

import Copyright from './copyright';
import Links from './links';

const Component: VFC = () => (
  <footer>
    <Copyright />
    <Links />
  </footer>
);

export default Component;
